/**
 * Parse Windows Agent command responses (mirrors extension services).
 */

export function parseInsertTextResponse(resp) {
  if (!resp) {
    return { ok: false, message: null, notConnected: true };
  }
  if (resp.success) {
    return {
      ok: true,
      message: resp.data?.message ?? null,
      notConnected: false,
    };
  }
  return {
    ok: false,
    message: resp.error ?? null,
    notConnected: false,
  };
}

export function parseImageSnipResponse(resp) {
  if (!resp?.success) {
    throw new Error(resp?.error ?? "Screen capture failed");
  }

  const data = resp.data ?? {};
  const payload = data.payload ?? data;
  const fileId = payload.fileId ?? payload.uploadedImageFileId;
  if (!fileId) {
    throw new Error("Screen capture returned no file id");
  }

  return {
    fileId,
    previewUrl: payload.previewUrl ?? null,
  };
}

export function parseSnipUploadResponse(resp, documentType) {
  if (!resp?.success) {
    throw new Error(resp?.error ?? "Screen capture failed");
  }

  const rawPayload = resp.data?.payload;
  const rows = Array.isArray(rawPayload)
    ? rawPayload
    : rawPayload && typeof rawPayload === "object"
      ? [rawPayload]
      : [];

  const first = rows[0];
  if (!first || typeof first !== "object") {
    throw new Error("Screen capture returned no file data");
  }

  const fileId = first.fileId ?? first.id;
  if (!fileId) {
    throw new Error("Screen capture returned invalid file id");
  }

  return {
    fileId,
    fileName: first.name ?? first.fileName ?? "screen_capture.jpg",
    documentType:
      first.documentType ?? first.document_type ?? documentType ?? null,
    url: first.url ?? null,
  };
}

export function parseWindowTitleList(windowTitle) {
  if (!windowTitle || typeof windowTitle !== "string") return [];
  return windowTitle
    .split("|")
    .map((part) => part.trim())
    .filter(Boolean);
}
